import type {SwiperOptions} from "swiper/types";
import SwiperArea, {
  type SwiperAreaProps,
} from "~/templates/areas/SwiperArea.vue";
import type {Component as VueComponent} from "@vue/runtime-core";

export const createSwiperArea: (
  swiperOptions: SwiperOptions,
) => VueComponent<SwiperAreaProps> = (swiperOptions: SwiperOptions) => {
  return h(SwiperArea as VueComponent, {
    swiperOptions,
  });
};
